import React, { useEffect, useRef } from 'react'
import ResultsSection from './ResultsSection'
import { Chart } from 'chart.js/auto'
import useTranslation from '../shared/TranslationProvider'
import useCareerExploration from './CareerExplorationProvider'

const SalarySection = ({ ...props }) => {
  const { careers, formatMoneyAmt } = useCareerExploration()

  const { t } = useTranslation('salary')
  const chartRef = useRef(null)
  const chartInstanceRef = useRef(null)

  useEffect(() => {
    const backgroundColors = ['#D0E8FF', '#FED0EE']

    const getData = () => {
      const dataSet = []
      careers.forEach((career, idx) => {
        const {
          salary_data: { twentyfive, median, seventyfive },
        } = career
        dataSet.push({
          data: [twentyfive, median, seventyfive],
          label: career.occupation.title,
          backgroundColor: backgroundColors[idx],
        })
      })
      return dataSet
    }

    if (chartRef.current) {
      const ctx = chartRef.current.getContext('2d')

      if (chartInstanceRef.current) {
        chartInstanceRef.current.destroy()
      }

      const displayLegend = careers.length === 2

      const labels = [t('low'), t('median'), t('high')]

      const datasets = getData()

      chartInstanceRef.current = new Chart(ctx, {
        type: 'bar',
        data: {
          labels: labels,
          datasets,
        },
        options: {
          scales: { y: { beginAtZero: true } },
          responsive: true,
          plugins: {
            legend: { display: displayLegend },
            tooltip: {
              enabled: true,
              callbacks: {
                label: function (ctx) {
                  let label = ctx.label || ''
                  if (ctx.parsed?.y !== null) {
                    label += ': ' + formatMoneyAmt(ctx.parsed.y)
                  }
                  return label
                },
              },
            },
          },
        },
      })
    }
  }, [careers, formatMoneyAmt, t])

  return (
    <ResultsSection
      className="col-span-2"
      section="salary"
      career={careers[0]}
      {...props}
    >
      <div>
        <canvas ref={chartRef} />
      </div>
    </ResultsSection>
  )
}

export default SalarySection
